import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c5cfdf0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container custom-container" }
const _hoisted_2 = { class: "footer-minimal" }
const _hoisted_3 = { class: "footer-vat text-center" }
const _hoisted_4 = ["textContent"]
const _hoisted_5 = { class: "footer-copyright text-center" }
const _hoisted_6 = { class: "mb-0" }

import { useCustomerStore } from "@/stores"
import ImprintModal from "@/views/modals/ImprintModal.vue"
import _ from "lodash"
import { onMounted, ref } from "vue"
import { isInViewport } from "@/helpers/common"
import { useAppStore } from "@/stores/app.store"
import { useCmsStore } from "@/stores/cms.store"

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*#__PURE__*/_defineComponent({
  __name: 'AppFooter',
  setup(__props) {

let isSalesRep: boolean
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let customer: any
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const imprintPgeContent = ref<any>("")
const appStore = useAppStore()
const cmsStore = useCmsStore()
const footer = ref<HTMLElement | null>(null)

const mountedComponent = () => {
  const customerStore = useCustomerStore()
  customer = customerStore.customer
  if (customer) {
    isSalesRep = _.get(customer, "customFields.eecom_tp_is_sales_rep", false)
  }
}
const onclickImprintPage = async () => {
  await cmsStore.fetchCms()
  imprintPgeContent.value = cmsStore.cms
}
mountedComponent()

const checkIfFooterVisible = () => {
  if (!footer.value) return

  appStore.isFooterVisible = isInViewport(footer.value)
}

onMounted(async () => {
  window.addEventListener("scroll", checkIfFooterVisible)
  await cmsStore.fetchCms()
  imprintPgeContent.value = cmsStore.cms
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("footer", {
      ref_key: "footer",
      ref: footer,
      class: "footer-main"
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", {
              textContent: _toDisplayString(_ctx.$t('eecom-teamportal.teamOrder.messages.vat&ShippingCosts'))
            }, null, 8, _hoisted_4)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("p", _hoisted_6, [
              _createTextVNode(_toDisplayString(_ctx.$t("eecom-teamportal.normalCustomer.addidasDttTitle")) + " | ", 1),
              _createElementVNode("a", {
                "data-bs-target": "#cms-imprint-page",
                "data-bs-toggle": "modal",
                href: "#",
                onClick: onclickImprintPage
              }, _toDisplayString(_ctx.$t("eecom-teamportal.footer.imprint")), 1)
            ])
          ])
        ])
      ])
    ], 512), [
      [_vShow, _unref(customer)]
    ]),
    (imprintPgeContent.value)
      ? (_openBlock(), _createBlock(ImprintModal, {
          key: 0,
          "sync-imprint-page": imprintPgeContent.value
        }, null, 8, ["sync-imprint-page"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})